import * as React from 'react';
import Icons from '../icons';

export default class Emptyowner extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="emptyScreen">
                <Icons name="Emptyowner" className="" /> <br />   
                <h2>No {this.props.type} found</h2>
            </div>
        );
    }
}